/*
* Contact Map
*/

export const MAP_STYLE = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]


/* global google */

$.fn.ContactMap = function() {
  let self = this
  self.map = undefined
  self.marker = undefined

  return function() {
    setTimeout(function() {
      self.map = new google.maps.Map(self.get(0), {
        styles: MAP_STYLE,
        disableDefaultUI: false,
        zoom: 14,
        scrollwheel: false,
        center: {
          lat: 45.5219875,
          lng: -73.5922921,
        },
      })

      self.marker = new google.maps.Marker({
        position: {
          lat: 45.5219875,
          lng: -73.5922921,
        },
        icon: {
          //url: '/img/elements/map-marker2.svg',
          //size: new google.maps.Size(50, 50),
          //scaledSize: new google.maps.Size(50, 50),
          //origin: new google.maps.Point(0, 0),
          //anchor: new google.maps.Point(9, 45),
        },
        map: self.map,
        url: "https://www.google.com/maps/place/Tendances+Concept+Montr%C3%A9al/@45.5219875,-73.5922921,17z/data=!4m14!1m7!3m6!1s0x4cc91bd4450a8d75:0xccd43349f36eb236!2sTendances+Concept+Montr%C3%A9al!8m2!3d45.5219838!4d-73.5901034!16s%2Fg%2F1tv23s5d!3m5!1s0x4cc91bd4450a8d75:0xccd43349f36eb236!8m2!3d45.5219838!4d-73.5901034!16s%2Fg%2F1tv23s5d",
      })

      google.maps.event.addListener(self.marker, 'click', function() {
        window.open(this.url, '_blank')
      })
    }, $.mlmi.mobile.isMobile ? 800 : 0)

    return self
  }()
}
